import type { AxiosHeaderValue } from 'axios';

export function checkResponseIsContentType(contentTypeHeader: AxiosHeaderValue | undefined, type: string): boolean {
  if (typeof contentTypeHeader === 'string') {
    return contentTypeHeader.includes(type);
  }

  if (Array.isArray(contentTypeHeader)) {
    return contentTypeHeader.some(header => header.includes(type));
  }

  return false;
}
